export class GraphAutoMakeOptions{
    constructor(
        public readonly openTabs: string[],
        public readonly hideChart: boolean
    ){

    }

    public readonly tabsPosition: boolean;
    public initiatedTabList: boolean;
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/graph-auto-make-options.ts